// extracted by mini-css-extract-plugin
module.exports = {"botVariantIndicator":"styles_botVariantIndicator__27XzU","botVariantIndicatorB":"styles_botVariantIndicatorB__1L-bD"};